import { useRef, useState, useEffect } from "react";
const compareWidths = (el1, el2) => {
  if (!el1 || !el2) {
    return false;
  }
  return el1.clientWidth === el2.clientWidth;
};
const useWidthComparison = () => {
  const containerRef = useRef(null);
  const componentRef = useRef(null);
  const [isWidthsEqual, setIsWidthsEqual] = useState(false);
  useEffect(() => {
    if (!("ResizeObserver" in window)) {
      return;
    }
    const checkWidths = () => {
      if (containerRef.current && componentRef.current) {
        setIsWidthsEqual(compareWidths(containerRef.current, componentRef.current));
      }
    };
    const resizeObserver = new ResizeObserver(checkWidths);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }
    if (componentRef.current) {
      resizeObserver.observe(componentRef.current);
    }
    checkWidths();
    return () => resizeObserver.disconnect();
  }, [containerRef, componentRef]);
  return { isWidthsEqual, containerRef, componentRef };
};
export {
  compareWidths,
  useWidthComparison
};
